import React from 'react';
import { useFormState } from './hooks/useFormState';
import ProspectFormFields from './ProspectFormFields'; // Fixed import - using default import
import { useProspectApi } from './hooks/useProspectApi';
import { useProspectForm } from './hooks/useProspectForm';

interface ProspectFormProps {
  status?: string;
  onSubmit: (success: boolean) => void;
}

export const ProspectForm: React.FC<ProspectFormProps> = ({ status = 'lead', onSubmit }) => {
  const { methods, isLoading, setIsLoading, showSuccessToast, showErrorToast } = useFormState();
  const { addContact, currentWorkspaceId } = useProspectApi();
  const { handleFormSubmit } = useProspectForm({
    methods,
    addContact, 
    setIsLoading,
    currentWorkspaceId,
    showSuccessToast,
    showErrorToast,
    status,
    onFormSubmit: onSubmit
  });

  // This adapts the form submit handler to work with both event-based and data-based submission
  const adaptedSubmitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    return handleFormSubmit(e);
  };

  return (
    <ProspectFormFields 
      form={methods}
      onSubmit={adaptedSubmitHandler}
      isSubmitting={isLoading}
    />
  );
};
